<template>
  <div class="ma-0 d-flex ga-1 pa-3 align-center flex-wrap">
    <v-spacer />
    <app-button
      v-if="quotableLink"
      :to="quotableLink"
      variant="outlined"
      color="orange"
      class="text-none rounded-pill"
      data-testid="view-quotable-button"
      :text="quotableText"
      :block="smAndDown"
      :prepend-icon="mdiOpenInNew"
    />
    <related-eapps-button
      :block="smAndDown"
      :eapps="eApps"
      text="eApp"
      create-text="Create eApp"
      can-create
      :prepend-icon="quoteAndApplyIcon"
      @create="convertToEapp"
    />
  </div>
</template>

<script setup>
import RelatedEappsButton from "@/components/shared/actions/RelatedEappsButton.vue";
import { useQuoteAndApplyIcon } from "@/composables/quote-and-apply-icon.composable";
import ConfirmationDialog from "@/dialogs/ConfirmationDialog.vue";
import { useDialogStore } from "@/stores/dialog";
import { useImpairedRiskQuoteView } from "@/stores/impaired-risk-quote-view";
import { getRouterLink, getTypeText } from "@/util/helpers";
import { mdiOpenInNew } from "@mdi/js";
import { storeToRefs } from "pinia";
import { markRaw, ref } from "vue";
import { useRouter } from "vue-router";
import { useDisplay } from "vuetify/lib/framework.mjs";

const impairedQuoteView = useImpairedRiskQuoteView();
const { quotableType, quotableId } = storeToRefs(impairedQuoteView);
const eApps = ref([]);

const dialog = useDialogStore();
const router = useRouter();
const { smAndDown } = useDisplay();

let quotableLink;
let quotableText;
if (quotableType.value && quotableId.value) {
  if (quotableType.value === "ElectronicApplication") {
    eApps.value.push({ id: quotableId.value });
  } else {
    quotableLink = getRouterLink(quotableType.value, quotableId.value);
    quotableText = `View ${getTypeText(quotableType.value)}`;
  }
}

const quoteAndApplyIcon = useQuoteAndApplyIcon();

function convertToEapp() {
  dialog.showDialog({
    component: markRaw(ConfirmationDialog),
    title: "Would you like to create an eApp from this Impaired Risk Quote?",
    subtitle: "Please confirm your intent.",
    func: async () => {
      const id = await impairedQuoteView.convertToEapp();
      router.push(getRouterLink("ElectronicApplication", id));
    }
  });
}
</script>
